import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const NewEmailBuilder = React.lazy(() => import('./views/pages/pntrs-emailbuilder'))
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Unsubscribe = React.lazy(() => import('./views/pages/unsubscribe/Unsubscribe'));
// const Main = React.lazy(() => import('./views/pages/pagebuilder-new/Main'));
const EmailBuilder = React.lazy(() => import('./views/pages/emailbuilder/EmailBuilder'));
const TemplateBuilder = React.lazy(() => import('./views/pages/template/template-builder/index'));
class App extends Component {

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} /> */}
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route exact path="/emailbuilder/:id" name="Email Builder" render={props => <EmailBuilder {...props}/>} />
              {/* <Route exact path="/new-emailbuilder" name="New Email Builder" render={props => <NewEmailBuilder {...props} />} /> */}
              <Route exact path="/_unsubs" name="Unsubscribe Page" render={props => <Unsubscribe {...props}/>} />
              <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
